(function () {
  'use strict';

  const CONFIG = {
    deliveryOptionName: 'お届け時期',
    toastDuration: 6000,
  };

  const STYLES = `
    #dc-overlay {
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.75);
      z-index: 999999;
      display: flex; align-items: center; justify-content: center;
    }
    #dc-dialog {
      background: #1a1a1a;
      color: #fff;
      border-radius: 12px;
      padding: 36px 32px 28px;
      max-width: 460px;
      width: 90%;
      box-shadow: 0 16px 60px rgba(0,0,0,0.6);
      font-family: sans-serif;
    }
    #dc-dialog h2 {
      margin: 0 0 14px;
      font-size: 18px;
      color: #fff;
      font-weight: 700;
    }
    #dc-dialog p {
      margin: 0 0 28px;
      font-size: 14px;
      line-height: 1.8;
      color: #ccc;
      white-space: pre-wrap;
    }
    .dc-actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .dc-actions button {
      padding: 14px 16px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: opacity 0.15s;
    }
    .dc-actions button:hover { opacity: 0.85; }
    #dc-keep    { background: #333; color: #fff; border: 1px solid #555; }
    #dc-replace { background: #fff; color: #1a1a1a; }
    #dc-cancel  { background: transparent; color: #888; font-weight: 400; font-size: 13px; text-decoration: underline; }

    #dc-toast {
      position: fixed; bottom: 24px; left: 50%;
      transform: translateX(-50%) translateY(100px);
      background: #1a1a1a; color: #fff; padding: 14px 20px;
      border-radius: 8px; font-size: 14px; line-height: 1.6;
      max-width: 420px; width: 90%; text-align: center;
      z-index: 999999; box-shadow: 0 4px 24px rgba(0,0,0,0.3);
      transition: transform 0.3s ease, opacity 0.3s ease;
      opacity: 0; font-family: sans-serif;
    }
    #dc-toast.dc-show { transform: translateX(-50%) translateY(0); opacity: 1; }
  `;

  function injectStyles() {
    if (document.getElementById('dc-style')) return;
    const s = document.createElement('style');
    s.id = 'dc-style';
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  function showToast(message) {
    injectStyles();
    let toast = document.getElementById('dc-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'dc-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = `⚠️ ${message}`;
    toast.classList.add('dc-show');
    setTimeout(() => toast.classList.remove('dc-show'), CONFIG.toastDuration);
  }

  function showDialog(existingDelivery, newDelivery) {
    return new Promise(resolve => {
      injectStyles();
      const overlay = document.createElement('div');
      overlay.id = 'dc-overlay';
      overlay.innerHTML = `
        <div id="dc-dialog">
          <h2> お届け時期が異なる商品があります</h2>
          <p>カートにはお届け時期「${existingDelivery}」の商品が入っています。\n今回追加する商品のお届け時期は「${newDelivery}」です。\n\nどちらにしますか？</p>
          <div class="dc-actions">
            <button id="dc-replace">カートを空にして「${newDelivery}」の商品を追加</button>
            <button id="dc-keep">カートを保持（「${existingDelivery}」のまま）</button>
            <button id="dc-cancel">キャンセル</button>
          </div>
        </div>`;
      document.body.appendChild(overlay);
      const done = r => { overlay.remove(); resolve(r); };
      overlay.querySelector('#dc-keep').onclick    = () => done('keep');
      overlay.querySelector('#dc-replace').onclick = () => done('replace');
      overlay.querySelector('#dc-cancel').onclick  = () => done('cancel');
      overlay.onclick = e => { if (e.target === overlay) done('cancel'); };
      const esc = e => { if (e.key === 'Escape') { done('cancel'); document.removeEventListener('keydown', esc); } };
      document.addEventListener('keydown', esc);
    });
  }

  async function getCart() {
    const r = await fetch('/cart.js?_=' + Date.now());
    return r.json();
  }

  async function clearCart() {
    await fetch('/cart/clear.js', { method: 'POST' });
  }

  async function removeCartItem(lineIndex) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 }),
    });
  }

  function getItemDelivery(item) {
    if (item.options_with_values) {
      const o = item.options_with_values.find(o => o.name.includes(CONFIG.deliveryOptionName));
      if (o) return o.value;
    }
    return null;
  }

  let isChecking = false;

  async function checkCartConflict(addedVariantId) {
    if (isChecking) return;
    isChecking = true;
    try {
      const cart = await getCart();
      if (!cart.items || cart.items.length < 2) return;

      const itemsWithDelivery = cart.items
        .map((item, idx) => ({ item, delivery: getItemDelivery(item), line: idx + 1 }))
        .filter(x => x.delivery);

      if (itemsWithDelivery.length < 2) return;

      const deliveries = [...new Set(itemsWithDelivery.map(x => x.delivery))];
      if (deliveries.length === 1) return;

      const newItem = cart.items.find(item => item.variant_id == addedVariantId);
      const newDelivery = newItem ? getItemDelivery(newItem) : null;
      const existingItem = itemsWithDelivery.find(x => x.item.variant_id != addedVariantId);
      const existingDelivery = existingItem?.delivery;

      if (!newDelivery || !existingDelivery) return;

      const choice = await showDialog(existingDelivery, newDelivery);

      if (choice === 'replace') {
        const newItemData = { id: addedVariantId, quantity: newItem.quantity };
        await clearCart();
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newItemData),
        });
        showToast(`カートを「${newDelivery}」の商品のみにしました。`);
      } else {
        const newItemLine = cart.items.findIndex(i => i.variant_id == addedVariantId) + 1;
        if (newItemLine > 0) await removeCartItem(newItemLine);
        showToast(`お届け時期が異なるため、追加した商品をカートから削除しました。`);
      }

      window.location.reload();

    } catch (err) {
      console.error('[DeliveryCheck] エラー:', err);
    } finally {
      isChecking = false;
    }
  }

  // fetch監視
  const _origFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = (typeof input === 'string' ? input : (input && input.url)) || '';
    const method = ((init && init.method) || 'GET').toUpperCase();

    if (!url.includes('/cart/add') || method !== 'POST') {
      return _origFetch.apply(this, arguments);
    }

    const response = await _origFetch.apply(this, arguments);

    response.clone().text().then(function(text) {
      try {
        const data = JSON.parse(text);
        const variantId = data.variant_id || (data.items && data.items[0] && data.items[0].variant_id);
        if (variantId) {
          console.log('[DeliveryCheck] 検知:', variantId);
          setTimeout(function() { checkCartConflict(variantId); }, 500);
        }
      } catch(e) {}
    }).catch(function() {});

    return response;
  };

  // XHR監視
  const _origOpen = XMLHttpRequest.prototype.open;
  const _origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._dc_method = method;
    this._dc_url = url;
    return _origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    const xhr = this;
    if (xhr._dc_url && xhr._dc_url.includes('/cart/add') && xhr._dc_method && xhr._dc_method.toUpperCase() === 'POST') {
      xhr.addEventListener('load', function() {
        try {
          const data = JSON.parse(xhr.responseText);
          const variantId = data.variant_id || (data.items && data.items[0] && data.items[0].variant_id);
          if (variantId) {
            console.log('[DeliveryCheck] XHR検知:', variantId);
            setTimeout(function() { checkCartConflict(variantId); }, 500);
          }
        } catch(e) {}
      });
    }
    return _origSend.apply(this, arguments);
  };

  // ポーリング監視（フォールバック）
  let lastCartCount = null;
  let lastCartItemIds = '';

  async function initPolling() {
    try {
      const cart = await getCart();
      lastCartCount = cart.item_count;
      lastCartItemIds = cart.items.map(i => i.variant_id + ':' + i.quantity).join(',');
    } catch(e) {}

    setInterval(async function() {
      if (isChecking) return;
      try {
        const cart = await getCart();
        const currentCount = cart.item_count;
        const currentIds = cart.items.map(i => i.variant_id + ':' + i.quantity).join(',');

        if (lastCartCount !== null && currentCount > lastCartCount && currentIds !== lastCartItemIds) {
          if (cart.items && cart.items.length > 0) {
            const latestVariantId = cart.items[0].variant_id;
            setTimeout(function() { checkCartConflict(latestVariantId); }, 300);
          }
        }

        lastCartCount = currentCount;
        lastCartItemIds = currentIds;
      } catch(e) {}
    }, 1000);
  }

  function init() {
    injectStyles();
    initPolling();
    console.log('[DeliveryCheck] 読み込み完了');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();